import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { FactComment } from '@/types';

interface UseCreateFactCommentParams {
  comment: string;
}

export const useCreateComment = (matterId: string, factId: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<FactComment, Error, UseCreateFactCommentParams>(
    async ({ comment }: UseCreateFactCommentParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          comment,
          url: window.location.href,
        },
      });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/comments/${factId}`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to create comment');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        // Invalidate queries to refetch the updated fact with new comment
        if (subsetId) {
          queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId }] });
        }
        queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.Fact, { factId }] });
        toast.success('Comment added successfully');
      },
      onError: (error) => {
        console.error('Error creating comment:', error);
        toast.error('Failed to add comment. Please try again.');
      },
    },
  );
};
